import {Component} from '@angular/core';
import {AuthService} from "../../core/services/auth.service";

@Component({
  selector: 'app-redirect-callback',
  standalone: true,
  imports: [],
  templateUrl: './redirect-callback.component.html',
})
export class RedirectCallbackComponent {
  constructor(
    private readonly authService: AuthService
  ) {
    this.authService.handleLoginRedirection()
  }

}
